import { useEffect, useState } from "react";
import { cn } from "@/shared/cn";
import { useTranslation } from "@/shared/i18n/LocaleProvider";
import { useTimeZone } from "@/shared/time/TimeZoneProvider";

export function Clock({ align = "start" }: { align?: "start" | "end" }) {
  const { locale } = useTranslation();
  const zone = useTimeZone();
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 10_000);
    return () => window.clearInterval(timer);
  }, []);
  const date = new Intl.DateTimeFormat(locale === "en" ? "en-GB" : "sv-SE", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: zone,
  }).format(now);
  const clock = new Intl.DateTimeFormat("sv-SE", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: zone,
  }).format(now);
  return (
    <div
      data-clock
      className={cn(
        "flex shrink-0 flex-col leading-[1.25]",
        align === "end" ? "mr-[4px] items-end text-right" : "items-start",
      )}
    >
      <b className="text-md font-medium text-(--ink)">
        {date.charAt(0).toUpperCase()}
        {date.slice(1)}
      </b>
      <span className="font-quant text-sm text-(--muted)">{clock}</span>
    </div>
  );
}
